import React from 'react';
import Text from '@zg-rentals/multibrand-ui/lib/Text';
import { formatDate } from '@common/paymentsUtils/dateUtils';
import { addMonths, subDays } from 'date-fns';
import DetailsCard from '@rental-manager/components/DetailsCard';
import { coerceToDate } from '@common/paymentsUtils/dateUtils';
import type { IFeaturePermissionObject } from '@rental-manager/models/Types';

type Props = {
  rentTerms: any;
  rentTermsExtendPermission: IFeaturePermissionObject;
  goToEditPaymentLengthPage: (...args: Array<any>) => void;
  goToEditTermLengthPage: (...args: Array<any>) => void;
};

class PaymentTerm extends React.Component<Props> {
  getFormattedEndDate(endDateForPayments: Date | string | number): string {
    const parsedEndDate = coerceToDate(endDateForPayments);
    if (parsedEndDate) {
      const addMonthDate = addMonths(parsedEndDate, 1);
      const subDayDate = subDays(addMonthDate, 1);
      return formatDate(subDayDate, 'MMM d, yyyy');
    }
    return 'N/A';
  }

  goToEditPage = (): void => {
    const { goToEditPaymentLengthPage, goToEditTermLengthPage, rentTerms } = this.props;
    if (rentTerms.tenantOnBoarded) {
      goToEditPaymentLengthPage(rentTerms);
    } else {
      goToEditTermLengthPage(rentTerms);
    }
  };

  render(): React.ReactNode {
    const { endDateForPayments, monthToMonth, paymentDateForFirstMonth } = this.props.rentTerms;
    const startDate = formatDate(paymentDateForFirstMonth, 'MMM d, yyyy');
    const endDate = this.getFormattedEndDate(endDateForPayments);
    const isRentTermsExtendAllowed = this.props.rentTermsExtendPermission.isAllowed;
    return (
      <DetailsCard title="Payment period" onEdit={this.goToEditPage} editingDisabled={!isRentTermsExtendAllowed}>
        <Text>First full rent payment: {startDate}</Text>
        <Text>{monthToMonth ? 'Month-to-month' : `Payment period ends: ${endDate}`}</Text>
      </DetailsCard>
    );
  }
}
export default PaymentTerm;
